module.exports = __webpack_public_path__ + "img/borchia_4.24a718a8.svg";